import React from 'react';

import ZoomControl from './ZoomControl';
import { MapTypeSwitcher } from '../MapTypeSwitcher/MapTypeSwitcher';
import { Props as MapProps } from '../index';

import { useMediaQuery } from 'common/hooks';
import { useStyles } from './styles';
import { useControlsStyles } from '../hooks';

export const Controls = ({ showZoomControl, showMapTypeControl }: Props) => {
  const controlsStyles = useControlsStyles();
  const classes = useStyles({ controlsStyles });
  const { isMobile } = useMediaQuery();

  return (
    <div className={classes.container}>
      <ZoomControl showZoomControl={showZoomControl} />
      {isMobile && <MapTypeSwitcher show={showMapTypeControl} />}
    </div>
  );
};

export interface Props extends Pick<MapProps, 'showZoomControl' | 'showMapTypeControl'> { }

